export const CHANGE_ASSIGNMENT_MODAL_OPEN = "CHANGE_ASSIGNMENT_MODAL_OPEN";
export const CHANGE_ASSIGNEE_ID = "CHANGE_ASSIGNEE_ID";
export const CHANGE_ASSIGNER_ID = "CHANGE_ASSIGNER_ID";
export const CHANGE_PARENTS_MAP = "CHANGE_PARENTS_MAP";
export const CHANGE_ROOT_NODE = "CHANGE_ROOT_NODE";
export const ADD_ASSIGNMENTS = "ADD_ASSIGNMENTS";
export const SET_ASSIGNMENTS = "SET_ASSIGNMENTS";
export const CHANGE_ITEMS_LIST = "CHANGE_ITEMS_LIST";
export const REMOVE_ASSIGNMENT = "REMOVE_ASSIGNMENT";
export const RESET_ASSIGNMENTS = "RESET_ASSIGNMENTS";

export const changeAssignmentModalOpen = (open) => ({
  type: CHANGE_ASSIGNMENT_MODAL_OPEN,
  payload: {
    open,
  },
});

export const changeAssigneeId = (id) => ({
  type: CHANGE_ASSIGNEE_ID,
  payload: {
    id,
  },
});

export const changeAssignerId = (id) => ({
  type: CHANGE_ASSIGNER_ID,
  payload: {
    id,
  },
});

export const changeParentsMap = (parentsMap) => ({
  type: CHANGE_PARENTS_MAP,
  payload: {
    parentsMap,
  },
});

export const changeRootNode = (node) => ({
  type: CHANGE_ROOT_NODE,
  payload: {
    node,
  },
});

export const addAssignments = (assignments) => ({
  type: ADD_ASSIGNMENTS,
  payload: {
    assignments,
  },
});

export const setAssignments = (assignments) => ({
  type: SET_ASSIGNMENTS,
  payload: {
    assignments,
  },
});

export const changeItemsList = (list) => ({
  type: CHANGE_ITEMS_LIST,
  payload: {
    list,
  },
});

export const removeAssignment = (id) => ({
  type: REMOVE_ASSIGNMENT,
  payload: { id },
});

export const resetAssignments = () => ({
  type: RESET_ASSIGNMENTS,
});
